import React, { useState } from 'react';
import { EmailResponse } from '../../types';

interface EmailPreviewModalProps {
  show: boolean;
  emailData: EmailResponse | null;
  onSend: (recipient: string, subject: string) => void;
  onClose: () => void;
}

// ===== Composant EmailPreviewModal =====
const EmailPreviewModal: React.FC<EmailPreviewModalProps> = ({
  show,
  emailData,
  onSend,
  onClose,
}) => {
  const [recipient, setRecipient] = useState('');
  const [subject, setSubject] = useState('');

  React.useEffect(() => {
    if (emailData) {
      setRecipient(emailData.recipient);
      setSubject(emailData.subject);
    }
  }, [emailData]);

  const handleSend = () => {
    if (!recipient.trim()) {
      alert('Veuillez saisir une adresse email destinataire');
      return;
    }
    if (!subject.trim()) {
      alert('Veuillez saisir un objet pour l\'email');
      return;
    }
    onSend(recipient, subject);
  };

  if (!show || !emailData) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content modal-xl" onClick={e => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50">
          <h3 className="text-xl font-bold text-gray-800 flex items-center">
            <i className="fas fa-eye mr-3 text-blue-600"></i> Prévisualisation de l'email
          </h3>
          <button onClick={onClose} className="modal-close text-gray-400 hover:text-gray-600 text-xl">
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="p-6 overflow-y-auto" style={{maxHeight: '60vh'}}>
          <div className="mb-4 space-y-2">
            <div className="flex items-center">
              <span className="font-semibold mr-2">À:</span>
              <input
                type="email"
                value={recipient}
                onChange={(e) => setRecipient(e.target.value)}
                className="form-input flex-1"
                placeholder="email@example.com"
              />
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-2">Objet:</span>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="form-input flex-1"
                placeholder="Objet de l'email"
              />
            </div>
          </div>

          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
            <div dangerouslySetInnerHTML={{ __html: emailData.htmlContent }} />
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex space-x-4">
          <button onClick={handleSend} className="flex-1 btn btn-success">
            <i className="fas fa-cloud-upload-alt mr-2"></i> Envoyer
          </button>
          <button onClick={onClose} className="btn btn-cancel ml-auto">
            <i className="fas fa-times mr-2"></i> Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailPreviewModal;
